/**
 * 生成uuid
 * @returns {string}
 */
export function uuid () {
  var s = []
  var hexDigits = '0123456789abcdefghijklmnopqrstuvwxyz'
  for (var i = 0; i < 36; i++) {
    s[i] = hexDigits.substr(Math.floor(Math.random() * 0x10), 1)
  }
  s[14] = '4' // bits 12-15 of the time_hi_and_version field to 0010
  s[19] = hexDigits.substr((s[19] & 0x3) | 0x8, 1) // bits 6-7 of the clock_seq_hi_and_reserved to 01
  s[8] = s[13] = s[18] = s[23] = '-'

  var uuid = s.join('')
  return uuid
}

/**
 * 筛选对象列表的数据
 * @param list
 * @param searchKey
 * @param resultKey
 * @param value
 * @returns {*}
 */
export function filterObjectList (list, searchKey, resultKey, value) {
  const filterList = list.filter(item => item[searchKey] === value)
  return (filterList.length > 0) ? filterList[0][resultKey] : ''
}



// WEBPACK FOOTER //
// ./src/utils/tools.js